import { cloneDeep, set } from "lodash";
import store from "../../../../store";
import i18n from "../../../../Utils/i18next/i18next";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { NotificationManager } from "react-notifications";
import { passwordValidator } from "../../../../Utils/Validators/Validators";

const { t } = i18n;

export const onSubmit = async (values, props) => {
  const { notifyUserReducer } = store.getState();
  const {
    updateTableRegistry,
    loadData,
    update,
    updateSingleRegistry,
    uuid,
    initialValues,
  } = props;

  const data = cloneDeep(values);

  if (values?.notifyRole?.value)
    set(data, "notifyRole", values?.notifyRole?.value);

  let payload;

  if (!update) {
    data.status = notifyUserReducer?.availableStatuses.find(
      (el) => !!el.isSelected,
    );

    const res = await GlobalAuthFetch({
      path: `/notifyuser`,
      method: "POST",
      data,
    });
    payload = res.payload;
  }

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/notifyuser/${uuid}`,
      method: "PATCH",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);

    return;
  }

  props.setErrorHeader(0, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();

  props.handleHide();
};

export const onValidate = (values, props) => {
  const { update } = props;
  const errorsStep0 = {};

  if (!values.contact) {
    errorsStep0.contact = t("global:notifyUser.errors.contact");
  }

  if (!values.notifyRole) {
    errorsStep0.notifyRole = t("global:notifyUser.errors.notifyRole");
  }

  if (!values.firstName) {
    errorsStep0.firstName = t("global:notifyUser.errors.firstName");
  }

  if (!values.lastName) {
    errorsStep0.lastName = t("global:notifyUser.errors.lastName");
  }

  if (!values.login) {
    errorsStep0.login = t("global:notifyUser.errors.login");
  }

  const shouldValidatePassword = !update || !!values.password;

  if (shouldValidatePassword) {
    if (!values.password) {
      errorsStep0.password = t("global:notifyUser.errors.password");
    } else {
      if (!passwordValidator(values.password)) {
        errorsStep0.password = t(
          "global:notifyUser.errors.passwordRequirements",
        );
      }
    }
  }

  if (shouldValidatePassword || !!values.repeatPassword) {
    if (!values.repeatPassword && !!values.password) {
      errorsStep0.repeatPassword = t("global:notifyUser.errors.repeatPassword");
    } else if (values.password !== values.repeatPassword) {
      errorsStep0.repeatPassword = t(
        "global:notifyUser.errors.passwordMismatch",
      );
    }
  }

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }

  if (
    !!props.steps[0]?.error &&
    !props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }

  return errorsStep0;
};
